
<div *ngIf="type == 'spinner'" class="spinner-border text-info spinner"></div>

<div *ngIf="type == 'ellipsis'" class="ellipsis-anim">
	<span>.</span><span>.</span><span>.</span>
</div>